<template>
    <div
        class="relative flex flex-col min-h-full p-2 border shadow-md bg-white dark:border-gray-200 dark:border dark:bg-gray-800 rounded-3xl shadow-black/5 ring-1 ring-black/5 show-card border-clay-200" >
        <a :href="`/${writer.urlSlug}`" :alt="writer.name" :title="writer.name" class="guide-img-container">
            <img :src="writer.imageUrl" :alt="`${writer.name} logo`"
                class="object-cover w-full aspect-square rounded-2xl">
        </a>
        <div class="flex flex-col flex-1 p-4">

            <div class="mt-2 font-medium text-base/7">
                <a :href="`/${writer.urlSlug}`" :alt="writer.name" :title="writer.name"
                    class="text-sa-raspberry-900"><span class="absolute inset-0"></span>
                    <h3 class="">{{ writer.name }}</h3>
                </a>
            </div>
            <div class="">

                <div class="text-sa-raspberry-600 text-sm/5">
                    <p>
                        <em class="">{{ writer.jobTitles?.join(', ') }}</em>
                        <span class="sr-only">
                            {{ writer.jobTitles?.join(', ') }},
                        </span>

                    </p>
                </div>
            </div>



            <div class="z-10 flex items-center gap-3 mx-auto mt-6">
                <fanning :id="writer.id" :number-of-fans="writer.fanCount"></fanning>
                <Bookmarking :id="writer.id"></Bookmarking>
            </div>
        </div>
    </div>
</template>







<script lang="ts" setup>
import {defineProps} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {AuthorDto} from "@/dtos";

const props = defineProps<{
    writer: AuthorDto,
}>()

const writer: AuthorDto = props.writer;

</script>
<style>

</style>